import { buildProps, definePropType } from '@ll-plus/utils'

import type { DescriptionsItemProp } from 'ant-design-vue/es/descriptions'
import type { ExtractPropTypes } from 'vue'
import { IconProps } from '../../icon'
import type Descriptions from './descriptions.vue'

export type IDescriptionsItemProp = DescriptionsItemProp & {
  type?: string
  key: string
}

export const descriptionsProps = buildProps({
  list: {
    type: definePropType<IDescriptionsItemProp[]>(Array),
  },
  data: {
    type: definePropType<Record<string, any>>(Object),
    default: () => ({}),
  },
  //  图标信息
  titleIcon: {
    type: definePropType<IconProps>(Object),
  },

  title: {
    type: String,
  },
  titleSize: {
    type: Number,
    default: 16,
  },
  titleColor: {
    type: String,
    default: 'var(--color-text)',
  },
} as const)
// props
export type DescriptionsProps = ExtractPropTypes<typeof descriptionsProps>

// instance
export type DescriptionsInstance = InstanceType<typeof Descriptions>
